import {
  ComponentParams,
  ComponentRendering,
  Field,
  LinkField,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { TranslationOptionsParams, AnchorTargetParams } from 'src/shared/shared.types';

export interface F01FormProps {
  rendering?: ComponentRendering & { params?: ComponentParams };
  params?: ComponentParams & F01FormParams;
  fields?: F01FormFields;
}

export type F01FormFields = {
  FormName?: Field<string>;
  ThankYouPageUrl?: LinkField;
  params?: ComponentParams;
};

export type F01FormParams = ComponentParams & TranslationOptionsParams & AnchorTargetParams;
